import DotDotDotMenu from '../../../components/DotDotDotMenu';
import PencilSquareIcon from '../../../components/icons/PencilSquareIcon';
import CopyIcon from '../../../components/icons/CopyIcon';
import type { Report } from './Report.types';
import TStrings from './Reports.i18n.js';

type ReportRowProps = {
    report: Report;
    editReportName: (report: Report) => void;
    onReportClicked: (report: Report) => void;
    duplicateReport: (report: Report) => void;
    deleteReport: (report: Report) => void;
    isDuplicating: boolean;
    isDeleting: boolean;
};

const ReportRow = ({
    report,
    editReportName,
    onReportClicked,
    duplicateReport,
    deleteReport,
    isDuplicating,
    isDeleting,
}: ReportRowProps) => {
    return (
        <div className="flex items-center justify-between pl-1 pr-6 py-3">
            <div
                className="flex-1 cursor-pointer hover:text-primary-700"
                onClick={() => onReportClicked(report)}
            >
                <span className="">{report.name}</span>
            </div>
            <DotDotDotMenu
                options={[
                    {
                        name: TStrings.EDIT_REPORT_BUTTON_TITLE,
                        icon: <PencilSquareIcon />,
                        onClick: () => editReportName(report),
                    },
                    {
                        name: isDuplicating
                            ? TStrings.DUPLICATE_REPORT_BUTTON_TITLE_LOADING
                            : TStrings.DUPLICATE_REPORT_BUTTON_TITLE,
                        icon: <CopyIcon />,
                        onClick: () => duplicateReport(report),
                    },
                    {
                        name: isDeleting
                            ? TStrings.DELETE_REPORT_BUTTON_TITLE_LOADING
                            : TStrings.DELETE_REPORT_BUTTON_TITLE,
                        isDelete: true,
                        onClick: () => deleteReport(report),
                    },
                ]}
            />
        </div>
    );
};
export default ReportRow;
